// src/pages/Storitve.tsx
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import SectionHeading from '@/components/SectionHeading';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const Storitve = () => {
  const services = [
    {
      title: 'Gradbeni stroji',
      description: 'Izvajanje del z gradbeno mehanizacijo.',
      image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070'
    },
    {
      title: 'Prevozi',
      description: 'Prevoz materialov in blaga.',
      image: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?q=80&w=2070'
    },
    {
      title: 'Montaža',
      description: 'Strokovna montaža keramike in kamna.',
      image: 'https://images.unsplash.com/photo-1581165825137-6d5b374c48bd?q=80&w=2071'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="pt-32">
        {/* Centered Title Section */}
        <div className="container-custom mx-auto mb-3">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-800 mb-4">
              Storitve z gradbenimi stroji in več
            </h1>
            <p className="text-xl md:text-2xl text-stone-600 max-w-3xl mx-auto">
              Celovite storitve za vaše gradbene projekte
            </p>
          </div>
        </div>

        <section className="py-4">
          <div className="container-custom">
            <SectionHeading 
              title="Naše storitve"
              subtitle="Profesionalne storitve za vse vaše potrebe"
            />
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white rounded-lg overflow-hidden shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-secondary border border-stone-200"
                >
                  <div className="h-56 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-stone-800 mb-2">{service.title}</h3>
                    <p className="text-stone-600 mb-4">{service.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="mt-16 text-center">
              <h3 className="text-2xl font-bold text-stone-800 mb-4">Potrebujete našo pomoč pri vašem projektu?</h3>
              <p className="text-lg text-stone-600 mb-8 max-w-3xl mx-auto">
                Naša ekipa izkušenih strokovnjakov vam je na voljo za vse vaše potrebe. 
                Naj gre za montažo keramike, prevoz materialov ali delo z gradbenimi stroji, 
                zagotovimo vam visoko kakovostno storitev.
              </p>
              <Button size="lg" className="bg-secondary hover:bg-secondary/90 text-white" asChild>
                <a href="/kontakt" className="flex items-center gap-2">
                  Zahtevaj ponudbo <ArrowRight size={16} />
                </a>
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Storitve;